import { types } from '../types/types';

export const lineChartReducer = (state = {}, action ) => {
    switch ( action.type ) {
        case types.dataLineChart:
            return{
                data: action.payload
            }     
        default:
            return state;
    }
}